<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <h2 class="subtitle">{{ $t("settings.productsCatalog") }}</h2>

    <div class="columns">
      <div class="column">
        <b-field :label="$t('settings.showCatalog')">
          <b-switch
            size="is-small"
            class="switch"
            type="is-primary"
            v-model="storeBeingManaged.configs.showCatalog"
            passive-type="is-secondary"
            @input="setShowCatalog"
          ></b-switch>

          {{
            storeBeingManaged.configs.showCatalog
              ? $t("common.Enabled")
              : $t("common.Disabled")
          }}
        </b-field>
      </div>

      <div class="column">
        <b-field
          :label="$t('settings.showStockQty')"
          v-if="storeBeingManaged.configs.showCatalog"
        >
          <b-switch
            size="is-small"
            class="switch"
            type="is-primary"
            v-model="storeBeingManaged.configs.showStockQty"
            passive-type="is-secondary"
            @input="setShowStockQty"
          ></b-switch>

          {{
            storeBeingManaged.configs.showStockQty
              ? $t("common.Enabled")
              : $t("common.Disabled")
          }}
        </b-field>
      </div>

      <div class="column">
        <b-field
          :label="$t('settings.allowProductAdditionViaCatalog')"
          v-if="storeBeingManaged.configs.showCatalog"
        >
          <b-switch
            size="is-small"
            class="switch"
            type="is-primary"
            v-model="storeBeingManaged.configs.addProductViaCatalog"
            passive-type="is-secondary"
            @input="setProductAdditionViaCatalog"
          ></b-switch>

          {{
            storeBeingManaged.configs.addProductViaCatalog
              ? $t("common.Enabled")
              : $t("common.Disabled")
          }}
        </b-field>
      </div>

      <div class="column">
        <b-field
          :label="$t('settings.showCatalogOutsideStoreMessage')"
          v-if="storeBeingManaged.configs.showCatalog"
        >
          <b-switch
            size="is-small"
            class="switch"
            type="is-primary"
            v-model="storeBeingManaged.configs.showCatalogOutsideStore"
            passive-type="is-secondary"
            @input="setShowCatalogOutsideStore"
          ></b-switch>

          {{
            storeBeingManaged.configs.showCatalogOutsideStore
              ? $t("common.Enabled")
              : $t("common.Disabled")
          }}
        </b-field>
      </div>
    </div>
    <br />

    <div class="columns">
      <div class="column">
        <b-field :label="$t('settings.replaceCatalog')">
          <b-field>
            <b-select
              :placeholder="$t('settings.pickStore')"
              v-model="copyCatalogSource"
            >
              <option value="">{{ $t("settings.pickStore") }}</option>
              <option v-for="s in otherStores" :value="s._id" :key="s._id">
                {{ s.storeInfo.name }}
              </option>
            </b-select>

            <p class="control">
              <button class="button is-info" @click="copyCatalog">
                {{ $t("settings.replace") }}
              </button>
            </p>
          </b-field>
        </b-field>
      </div>

      <div class="column">
        <b-field :label="$t('settings.deleteCurrentCatalog')">
          <button class="button is-danger" @click="deleteCatalog">
            {{ $t("settings.delete") }}
          </button>
        </b-field>
      </div>
    </div>

    <b-modal :active.sync="isCopyCatalogModalOpen">
      <copy-catalog-modal
        :sourceStoreId="copyCatalogSource"
        :destinyStoreId="storeBeingManaged._id"
        :sourceStoreName="sourceStoreName"
        :destinyStoreName="storeBeingManaged.storeInfo.name"
      />
    </b-modal>

    <b-modal :active.sync="isDeleteCatalogModalOpen">
      <delete-catalog-modal
        :storeId="storeBeingManaged._id"
        :storeName="storeBeingManaged.storeInfo.name"
      />
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import copyCatalogModal from "./catalog/CopyCatalogModal";
import deleteCatalogModal from "./catalog/DeleteCatalogModal";

export default {
  mixins: [common],

  data() {
    return {
      isLoading: false,
      copyCatalogSource: "",
      isCopyCatalogModalOpen: false,
      isDeleteCatalogModalOpen: false
    };
  },

  components: {
    copyCatalogModal,
    deleteCatalogModal
  },

  computed: {
    ...mapGetters(["storeBeingManaged", "stores"]),

    otherStores() {
      return this.stores.filter(s => {
        return s._id !== this.storeBeingManaged._id;
      });
    },

    sourceStoreName() {
      const stores = this.stores.filter(s => {
        return s._id === this.copyCatalogSource;
      });
      return stores.length ? stores[0].storeInfo.name : "";
    }
  },

  methods: {
    copyCatalog() {
      if (this.copyCatalogSource === "") {
        this.alertError({ message: "MISSING_SOURCE_CATALOG" });
      } else {
        this.isCopyCatalogModalOpen = true;
      }
    },

    deleteCatalog() {
      this.isDeleteCatalogModalOpen = true;
    },

    setShowCatalog() {
      this.isLoading = true;
      this.$store
        .dispatch("setShowCatalog", {
          storeId: this.storeBeingManaged._id,
          status: this.storeBeingManaged.configs.showCatalog
        })
        .then(res => {
          if (res.data.result === "error") {
            this.storeBeingManaged.configs.showCatalog = !this.storeBeingManaged
              .configs.showCatalog;
            this.alertError(res.data);
          } else {
            this.$buefy.toast.open({
              message: `${this.$t("settings.showCatalogMessage")}: ${
                this.storeBeingManaged.configs.showCatalog
                  ? this.$t("common.enabled-f")
                  : this.$t("common.disabled-f")
              }!`,
              type: "is-success",
              position: "is-bottom",
              duration: 5000
            });
          }
        })
        .catch(() => {
          this.storeBeingManaged.configs.showCatalog = !this.storeBeingManaged
            .configs.showCatalog;
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    setShowCatalogOutsideStore() {
      this.isLoading = true;
      this.$store
        .dispatch("setShowCatalogOutsideStore", {
          storeId: this.storeBeingManaged._id,
          status: this.storeBeingManaged.configs.showCatalogOutsideStore
        })
        .then(res => {
          if (res.data.result === "error") {
            this.storeBeingManaged.configs.showCatalogOutsideStore = !this
              .storeBeingManaged.configs.showCatalogOutsideStore;
            this.alertError(res.data);
          } else {
            this.$buefy.toast.open({
              message: `${this.$t("settings.showCatalogMessage")}: ${
                this.storeBeingManaged.configs.showCatalogOutsideStore
                  ? this.$t("common.enabled-f")
                  : this.$t("common.disabled-f")
              }!`,
              type: "is-success",
              position: "is-bottom",
              duration: 5000
            });
          }
        })
        .catch(() => {
          this.storeBeingManaged.configs.showCatalogOutsideStore = !this
            .storeBeingManaged.configs.showCatalogOutsideStore;
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    setShowStockQty() {
      this.isLoading = true;
      this.$store
        .dispatch("setShowStockQty", {
          storeId: this.storeBeingManaged._id,
          status: this.storeBeingManaged.configs.showStockQty
        })
        .then(res => {
          if (res.data.result === "error") {
            this.storeBeingManaged.configs.showStockQty = !this
              .storeBeingManaged.configs.showStockQty;
            this.alertError(res.data);
          } else {
            this.$buefy.toast.open({
              message: `${this.$t("settings.showStockQtyMessage")}: ${
                this.storeBeingManaged.configs.showStockQty
                  ? this.$t("common.enabled-f")
                  : this.$t("common.disabled-f")
              }!`,
              type: "is-success",
              position: "is-bottom",
              duration: 5000
            });
          }
        })
        .catch(() => {
          this.storeBeingManaged.configs.showStockQty = !this.storeBeingManaged
            .configs.showStockQty;
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    setProductAdditionViaCatalog() {
      this.isLoading = true;
      this.$store
        .dispatch("setProductAdditionViaCatalog", {
          storeId: this.storeBeingManaged._id,
          status: this.storeBeingManaged.configs.addProductViaCatalog
        })
        .then(res => {
          if (res.data.result === "error") {
            this.storeBeingManaged.configs.addProductViaCatalog = !this
              .storeBeingManaged.configs.addProductViaCatalog;
            this.alertError(res.data);
          } else {
            this.$buefy.toast.open({
              message: `${this.$t(
                "settings.setProductAdditionViaCatalogMessage"
              )}: ${
                this.storeBeingManaged.configs.addProductViaCatalog
                  ? this.$t("common.enabled-f")
                  : this.$t("common.disabled-f")
              }!`,
              type: "is-success",
              position: "is-bottom",
              duration: 5000
            });
          }
        })
        .catch(() => {
          this.storeBeingManaged.configs.addProductViaCatalog = !this
            .storeBeingManaged.configs.addProductViaCatalog;
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>
